/**
 * ゾーン早見表（旧 ZONE CHART。v2 で入口を設けた）
 *
 * 入口：学ぶのタイル、ピン編集の「早見表」、初回のホーム。
 * ピン編集から開くときは、シートの上に重ねて開き、入力中の値を失わない（overlay）。
 */

import { showScreen, goBack, escapeHtml, icon, ZONE_ROMAN, ZONE_NAMES, ZONE_EXAMPLES } from './ui.js';

function contentHtml() {
  return `
    <div class="page-head" style="display:block">
      <div class="eyebrow">zone chart</div>
      <div class="page-title">ゾーン早見表</div>
      <p class="sub" style="margin:10px 0 0;font-size:13px;line-height:1.7">隣り合うゾーンの差は 1 段。測った面を、仕上がりで何ゾーンに見せたいかを決める。</p>
      <div style="font:italic 400 15px/1.5 var(--font-en);margin-top:14px;padding:12px 0;border-top:1px solid var(--color-rule);border-bottom:1px solid var(--color-rule)">“Expose for the shadows, develop for the highlights.”</div>
      <p class="sub" style="margin:6px 0 0;font-size:12px">シャドウのために露光し、ハイライトのために現像する。</p>
    </div>
    <div class="body"><div style="padding:0 var(--gutter) 40px">
      ${ZONE_ROMAN.map((r, i) => `
        <div class="zrow" style="animation-delay:${i * 45}ms">
          <span class="zrow__sw zc-${i}"></span>
          <span class="zrow__r">${r}</span>
          <div style="flex:1;min-width:0"><div style="font:500 14px/1.3 var(--font-jp-sans)">${escapeHtml(ZONE_NAMES[i])}</div><div class="sub" style="font-size:12px;line-height:1.5;margin-top:2px">${escapeHtml(ZONE_EXAMPLES[i])}</div></div>
        </div>`).join('')}
    </div></div>`;
}

export function openZoneChart(opts = {}) {
  if (opts.overlay) {
    const app = document.getElementById('app');
    const el = document.createElement('div');
    el.className = 'screen screen--active';
    el.style.zIndex = '26';
    el.style.animation = 'zn-sheet-in .42s cubic-bezier(.2,.9,.2,1) both';
    el.innerHTML = `<div class="safe-top"></div><div class="bar"><button class="bar__btn" type="button" data-zc-close aria-label="閉じる">${icon('close', 20)}</button><span></span></div>${contentHtml()}`;
    el.querySelector('[data-zc-close]').addEventListener('click', () => {
      el.style.animation = 'zn-sheet-out .24s cubic-bezier(.4,0,1,1) both';
      setTimeout(() => el.remove(), 240);
    });
    app.appendChild(el);
    return;
  }
  const el = document.getElementById('screen-zone-chart');
  el.innerHTML = `<div class="safe-top"></div><div class="bar"><button class="bar__btn" type="button" data-zc-close aria-label="閉じる">${icon('close', 20)}</button><span></span></div>${contentHtml()}`;
  el.querySelector('[data-zc-close]').addEventListener('click', () => goBack());
  showScreen('zone-chart');
}
